module.exports = __webpack_public_path__ + "67eb753f8c80c78afbb2854975300b22.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/trumpet/9_G#2.mp3
// module id = 125
// module chunks = 0